import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { HighlightConfig } from '../../types/executiveChat';
import './HighlightBox.css';

interface HighlightBoxProps {
  config: HighlightConfig;
}

const HighlightBox: React.FC<HighlightBoxProps> = ({ config }) => {
  return (
    <div className={`exec-highlight-box exec-highlight-${config.type}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {config.content}
      </ReactMarkdown>
    </div>
  );
};

export default HighlightBox;

